import { Component, OnInit } from "@angular/core"
import { Location } from '@angular/common';
import { AppService } from '../../../app.service';
import { GETAboutPopupComponent } from "../about-popup/about-popup.component";
import { UserService } from "../../../../app/shared/services/user.service";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "navbar-side",
    templateUrl: './navbar-side.component.html'
})
export class NavbarSide {
    NavigationItems: NavItem[];
    oldGETUri: string;
    identityServerUri: string;
    public navType = NavType;
    public menuVisible: string ='show-menu';

    constructor(private _appService: AppService,private _dialog: MatDialog,private _user:UserService
        ) { }
        isJobRoleDefault:boolean=true;
        isSupervisor:boolean=false;
        isAdmin:boolean=false;
        isInspector:boolean=false;

    ngOnInit() {

        this.LoadJobRoles();
       

        

       
        // this._appService.getMenuVisible().subscribe(result => {
        //     if (result)
        //         this.menuVisible = 'show-menu';
        //     else
        //         this.menuVisible = '';
        // });
    }

     openAbout() {
        this._dialog.open(GETAboutPopupComponent, {
              panelClass: 'removeModalOverflow',
              data: {
              }
          });
      }
    LoadJobRoles(){

    this._user.getUserJobRoles().subscribe(roles=>{
        // this._appService.getApplicationConfigValue("IdentityServerUri").subscribe(result => {
        //     this.identityServerUri = result;
        //     console.log("this.identityServerUri",this.identityServerUri)
        // });

        roles.forEach(r => {
            switch (r.Name) {
                case 'Inspectors':
                    this.isJobRoleDefault = false;
                    this.isInspector=true;
                    break;
                case 'Interpreters':
                    this.isJobRoleDefault = false;
                    break;
                case 'Super User':  
                    this.isJobRoleDefault = false;
                    break;
                case 'Administrator':
                    this.isJobRoleDefault = false;
                    this.isAdmin=true;
                    break;
                case 'Supervisor':
                    this.isJobRoleDefault = false;
                    this.isSupervisor=true;
                    break;
            }
        });

        
        if(this.isJobRoleDefault== true){

            console.log("IsJobRole", this.isJobRoleDefault)
            this.NavigationItems = 
            [{
                icon: 'home',
                text: 'Dashboard',
                type: NavType.RouterLink,
                location: 'dashboard'
            }];
        }else{
            this._appService.getApplicationConfigValue("oldGETUri").subscribe(result => {
                this.oldGETUri = result
                this.NavigationItems =
                    [{
                        icon: 'home',
                        text: 'Dashboard',
                        type: NavType.RouterLink,
                        location: 'dashboard'
                    },
                    // {
                    //     icon: 'layers',
                    //     text: 'My Implements',
                    //     type: NavType.Link,
                    //     location: this.oldGETUri + 'GET/MyImplements.aspx'
                    // },
                    // {
                    //     icon: 'find_in_page',
                    //     text: 'My Equipment',
                    //     type: NavType.Link,
                    //     location: this.oldGETUri + 'GET/FindEquipment.aspx'
                    // },
                    {
                        icon: '',
                        text: 'Inspections',
                        type: NavType.SubHeader,
                        location: ''
                    },
                    {
                        icon: 'find_in_page',
                        text: 'Find Inspection',
                        type: NavType.Link,
                        location: this.oldGETUri + 'GET/FindInspection.aspx'
                    },
                    // {
                    //     icon: 'note_add',
                    //     text: 'Add Observation Point',
                    //     type: NavType.Link,
                    //     location: this.oldGETUri + 'GET/ManageMyImplements.aspx'
                    // },
                    {
                        icon: 'phone_android',
                        text: 'Download App',
                        type: NavType.Link,
                        location: this.oldGETUri + 'GET/GET_Mobile_App/GETMobile.apk'
                    },
                    {
                        icon: '',
                        text: 'Implement Setup',
                        type: NavType.SubHeader,
                        location: ''
                    },
                    {
                        icon: 'list',
                        text: 'Observation Lists',
                        type: NavType.Link,
                        location: this.oldGETUri + 'GET/SelectObservationListCustomer.aspx'
                    },
                    {
                        icon: 'note_add',
                        text: 'New Implement',
                        type: NavType.RouterLink,
                        location: 'setup/implement'
                    },
                    {
                        icon: 'file_copy',
                        text: 'Copy Implement',
                        type: NavType.RouterLink,
                        location: 'copy/implement'
                    },
                    {
                        icon: 'edit',
                        text: 'Modify Existing Implement',
                        type: NavType.RouterLink,
                        location: 'setup/existing-implement'
                    },
                    {
                        icon: 'settings',
                        text: 'New Equipment',
                        type: NavType.RouterLink,
                        location: 'setup/equipment'
                    },
                    // {
                    //     icon: 'dashboard',
                    //     text: 'Implement Templates',
                    //     type: NavType.RouterLink,
                    //     location: 'template'
                    // },
                    // {
                    //     icon: 'build',
                    //     text: 'Component Types',
                    //     type: NavType.Link,
                    //     location: this.oldGETUri + 'GET/ManageComponentTypes.aspx'
                    // },
                    // {
                    //     icon: '',
                    //     text: 'Admin',
                    //     type: NavType.SubHeader,
                    //     location: ''
                    // },
                    // {
                    //     icon: 'language',
                    //     text: 'Preferences',
                    //     type: NavType.Link,
                    //     location: 'preferences'
                    // }
                ];
                    //{
                    //    icon: 'folder_shared',
                    //    text: 'Administration',
                    //    type: NavType.Link,
                    //    location: this.oldGETUri + 'GET/TTUserManagement.aspx'
                    //}]
 
                    this._appService.getApplicationConfigValue("IdentityServerUri").subscribe(result => {
                        this.identityServerUri = result;
                        // this.NavigationItems = this.NavigationItems.concat(
                        //     [{
                        //         icon: 'folder_shared',
                        //         text: 'Administration',
                        //         type: NavType.Link,
                        //         location: this.identityServerUri + 'administration/'
                        //     }]);
                    
                    // this.NavigationItems = this.NavigationItems.concat(
                    //     [{
                    //         icon: 'folder_shared',
                    //         text: 'Administration',
                    //         type: NavType.Link,
                    //         location: this.identityServerUri + 'administration/'
                    //     }]);
               
                    this.NavigationItems = this.NavigationItems.concat(
                        [{
                                icon: '',
                                text: 'Component Rebuild Centre(CRC)',
                                type: NavType.SubHeader,
                                location: ''
                         },
                         {
                            icon: 'dynamic_form',
                            text: 'CRC Dashboard',
                            type: NavType.Link,
                            location: 'fecr/dashboard'
                            },
                    ]);
                if(this.isSupervisor==true || this.isAdmin==true || this.isInspector==true || this.isJobRoleDefault==false){

                   
                        this.NavigationItems = this.NavigationItems.concat(
                    [{
                            icon: '',
                            text: 'Digital Forms',
                            type: NavType.SubHeader,
                            location: ''
                     },
                ]);
               
                }
                if(this.isAdmin==true){
                    this.NavigationItems = this.NavigationItems.concat(
                        [
                         {
                            icon: 'dynamic_form',
                            text: 'Form Administration',
                            type: NavType.Link,
                            location: 'digitalform/adminsearch'
                        }]);
                }

                if(this.isSupervisor==true || this.isInspector==true || this.isJobRoleDefault==false){
                    this.NavigationItems = this.NavigationItems.concat(
                        [
                            {
                                icon: 'find_in_page',
                                text: 'Search Digital Form',
                                type: NavType.Link,
                                location: 'digitalform/search'
                            }]);
                }

                if(this.isSupervisor==true || this.isInspector==true || this.isJobRoleDefault==false){
                    this.NavigationItems = this.NavigationItems.concat(
                        [
                            {
                        icon: '',
                        text: 'Admin',
                        type: NavType.SubHeader,
                        location: ''
                        },
                        {
                        icon: 'language',
                        text: 'Preferences',
                        type: NavType.Link,
                        location: 'preferences'
                        },
                        {
                                    icon: 'folder_shared',
                                    text: 'Administration',
                                    type: NavType.Link,
                                    location: this.identityServerUri + 'administration/'
                        },

                        {
                            icon: 'info',
                            text: 'About',
                            type: NavType.PopUp,
                            location: ''
                        },

                       
                        ]);
                }
                
                });
            });
        }
      
    });



    }

}



class NavItem {
    text: string;
    type: NavType;
    location: string;
    icon: string;
}

enum NavType {
    RouterLink,
    Link,
    SubHeader,
    PopUp,
}
